import { __extends } from "tslib";
import * as React from 'react';
import Check from 'wix-ui-icons-common/Check';
import s from '../solution-page-views/solution-overview/solution-overview.scss';
import { Box, TextButton } from 'wix-style-react';
var BenefitPreviewWrapper = /** @class */ (function (_super) {
    __extends(BenefitPreviewWrapper, _super);
    function BenefitPreviewWrapper(props) {
        return _super.call(this, props) || this;
    }
    BenefitPreviewWrapper.prototype.render = function () {
        return this.props.shouldReplace ? (React.createElement(Box, { key: this.props.index, align: "center", direction: "horizontal", verticalAlign: "middle", marginBottom: "8px", inline: true },
            React.createElement(Check, { size: "18", className: s.overViewCheckMark }),
            " \u00A0 \u00A0",
            ' ',
            React.createElement(TextButton, { dataHook: "benefit-" + this.props.index, as: "a", href: "https://dev.wix.com/dc3/my-apps/" + this.props.appId + "/market/info/basic-info", target: "_blank" }, this.props.benefit))) : !this.props.shouldReplace && this.props.benefit ? (this.props.children) : null;
    };
    return BenefitPreviewWrapper;
}(React.Component));
export { BenefitPreviewWrapper };
export var fillWithPreviewBenefits = function (benefits, t, isPreview) {
    var previewBenefits = [
        { benefit: t('solution.page.preview.benefit1'), shouldReplace: true },
        { benefit: t('solution.page.preview.benefit2'), shouldReplace: true },
        { benefit: t('solution.page.preview.benefit3'), shouldReplace: true },
        { benefit: t('solution.page.preview.benefit4'), shouldReplace: true },
    ];
    return !isPreview || benefits.length > 3
        ? benefits.map(function (benefit) {
            return { benefit: benefit, shouldReplace: false };
        })
        : previewBenefits.map(function (ctaBenefit, index) {
            return index < benefits.length
                ? { benefit: benefits[index], shouldReplace: false }
                : ctaBenefit;
        });
};
//# sourceMappingURL=benefit-wrapper.js.map